import { Helmet } from "react-helmet-async";
import { BUSINESS_NAME, BUSINESS_DESCRIPTION, PHONE } from "@/lib/constants";

interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  type?: "website" | "article" | "local_business";
  schema?: object | object[];
}

const SEO = ({
  title,
  description,
  canonicalUrl,
  type = "website",
  schema = [],
}: SEOProps) => {
  const fullTitle = `${title} | ${BUSINESS_NAME}`;
  const baseUrl = "https://truamericanplumbing.com";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type === "local_business" ? "business.business" : type} />
      {canonicalUrl && <meta property="og:url" content={`${baseUrl}${canonicalUrl}`} />}
      <meta property="og:image" content={`${baseUrl}/og-image.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={BUSINESS_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${baseUrl}/og-image.png`} />

      {/* Schema.org JSON-LD */}
      {(() => {
        const schemas = Array.isArray(schema) ? schema : [schema];
        return schemas.map((s, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(s)}
          </script>
        ));
      })()}
    </Helmet>
  );
};

export default SEO;
